import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.numberOfRows),function(number){return _c('tr',{key:number},_vm._l((_vm.headers),function(header,index){return _c('td',{key:index},[_c(VSkeletonLoader,{staticClass:"w-table-cell-skeleton",attrs:{"type":"table-cell"}})],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }